"use client";

import { useUser } from "@clerk/nextjs";
import { Skeleton } from "@/components/ui/skeleton";
import type { HeaderThemeType } from "@/types/common.types";
import { AccountMenu } from "./account-menu";
import { SignInMenu } from "./sign-in-menu";

export const HeaderAccount = ({
  theme,
  hideSignIn = false,
}: {
  theme?: HeaderThemeType;
  hideSignIn?: boolean;
}) => {
  const { isLoaded, isSignedIn } = useUser();

  if (!isLoaded) {
    return <Skeleton className="h-12 w-36 rounded-xl" />;
  }

  if (isSignedIn) {
    return <AccountMenu theme={theme} />;
  }

  return hideSignIn ? null : <SignInMenu />;
};
